import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { UsersActionsState } from 'app/states/users-actions/users-actions.state';
import { Subscription } from 'rxjs';

@Component({
    selector: 'mh-core-lib-actions-wrapper',
    templateUrl: './actions-wrapper.component.html',
    styleUrls: ['./actions-wrapper.component.scss'],
    standalone: false
})
export class CoreLibActionsWrapperComponent implements OnInit, OnDestroy {
  isAllowed = false;
  subscription: Subscription;
  @Input() slug = '';
  @Input() hideContentBySlug = false;
  @Input() tooltipPosition = 'above';
  @Input() message = 'core-lib.action-wrapper.block';
  /** Parámetros extra de interpolación para `message`. Se fusionan con `role`, que siempre va. */
  @Input() messageParams: Record<string, any> = {};
  @Input() skipValidation = false;
  @Output() isAllowedResult:EventEmitter<boolean> = new EventEmitter<boolean>();
  @Select(UsersActionsState.getActions) actions$;

  constructor(private store: Store) {}

  ngOnInit() {
    this.subscription = this.actions$.subscribe((actions) => {
      this.isAllowed = !!actions.find((action) => action.slug === this.slug);
      this.isAllowedResult.emit(this.isAllowed);
    });
  }

  get userRole() {
    return this.store.selectSnapshot(UsersActionsState.role);
  }

  get translateParams() {
    return { role: this.userRole, ...this.messageParams };
  }

  get isBlocked() {
    return !this.isAllowed && !this.skipValidation;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  handleClick(event: MouseEvent) {
    if (this.isBlocked) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
  }
}
